<h3 class="mb-4">{{ 'b2b.b2b-program-file-upload.head' | translate }}</h3>

<div class="d-flex flex-column flex-nowrap">
    <div
        class="font-size-sm mb-3"
        [innerHTML]="
            (b2bPrgType === b2bProgramTypeEnum.NumberOfTrips
                ? 'b2b.b2b-program-file-upload.descriptionNumberOfTrips'
                : 'b2b.b2b-program-file-upload.description'
            ) | translate
        "></div>
    <form>
        <input class="user-image__control" type="file" #fileInput (change)="fileChange($event)" />
    </form>

    <button class="btn btn-primary w-100 mb-3 rounded" [disabled]="loadingFile" (click)="openFileDialog(uploadRidersFileType.Add)">
        {{ 'b2b.b2b-program-file-upload.add' | translate }}
    </button>

    <button class="btn btn-outline w-100 rounded" [disabled]="loadingFile" (click)="openFileDialog(uploadRidersFileType.Remove)">
        {{ 'b2b.b2b-program-file-upload.remove' | translate }}
    </button>
</div>
